import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GithubIcon from '@mui/icons-material/GitHub';
import RubygemsIcon from '@mui/icons-material/Diamond';
import TwitterIcon from '@mui/icons-material/Twitter';
import MailIcon from '@mui/icons-material/Mail';

export const items = {
  Github: {
    icon: <GithubIcon fontSize="small" color="primary" />,
    href: 'https://github.com/voislavj',
  },
  LinkedIn: {
    icon: <LinkedInIcon fontSize="small" color="primary" />,
    href: 'https://linkedin.com/voislavj',
  },
  RubyGems: {
    icon: <RubygemsIcon fontSize="small" color="primary" />,
    href: 'https://rubygems.org/profiles/voislavj',
  },
  Twitter: {
    icon: <TwitterIcon fontSize="small" color="primary" />,
    href: 'https://twitter.com/voislavj',
  },
  Email: {
    icon: <MailIcon fontSize="small" color="primary" />,
    href: 'mailto:voislavj@gmail.com',
  },
};

export const useCommonStyles = theme => ({
  link: {
    width: '36px',
    height: '36px',
    color: 'white',
    '&:hover': {
      background: 'white',
    },
    '&:hover svg': {
      color: theme.palette.secondary.main,
    },
  },
  flag: {
    width: '20px',
    height: '20px',
    borderRadius: '10px',
    backgroundImage: 'url(/img/flags.png)',
    transition: 'background-position 0.8s ease-out',
    border: '1px solid #555',
    backgroundPosition: '0 -20px',
  },
  flagEN: {
    backgroundPosition: '0 0',
  },
  mobileFab: {
    background: '#ffb900',
    color: 'white',
    '&:hover': {
      background: '#ffb900',
    },
    '& svg': {
      color: 'white',
    },
  },
});